<div class="text">
  <div
    class="section-title"
    [innerHTML]="title | translate"
    *ngIf="title"
  ></div>
  <ng-content select=".section-title"></ng-content>
  <div class="section-desc" *ngIf="desc" [innerHTML]="desc | translate"></div>
</div>
